import { createFileRoute } from '@tanstack/react-router';
import { DesignGallery } from '../design/gallery.js';

// Public (no sign-in): the design gallery is what UI reviewers open first.
export const Route = createFileRoute('/design')({
  component: DesignGallery,
});
